<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowAvgSellingPricePostDisc',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'net_ha_revenue', throughMonth),
          this.getYtdByField(yearObj, 'net_units_sold', throughMonth),
          0);
      },
    },
  };
</script>
